import $ from 'cash-dom';

/**
 * This module looks for all a[href="#block-id"] links and adds smooth scrolling
 */
export class AnchorScrollModule {

    static name = 'anchorscroll';

    constructor(node) {

        $(node).find('a[href^="#"]').on('click', this.handleClick);
    }

    handleClick = (e) => {
        const hash = $(e.currentTarget).attr('href').split('#')[1];
        const target = $(`a[name="${hash}"]`);
        if(target.length) {
            e.preventDefault();
            target[0].scrollIntoView({ behavior: 'smooth' });
        }
    }
}